

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, VModel} from "vue-property-decorator";

@Component({})
export default class SimpleAlertDialog extends Vue {
  @PropSync('show')
  public showValue!: boolean;

  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public text!: string;

  @Prop({default : false})
  public persistent!: boolean;

  @Prop({ default: true })
  public wide!: boolean|string;

  @Prop({ default: false })
  public cantBeUndone!: boolean;

  public get maxWidth(): number {
    if (this.wide === 'extra') {
      return 800;
    }
    else if (this.wide !== false) {
      return 600;
    }
    return 300;
  }
}

